// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPresignUrlRequestDto
 */
export interface IPresignUrlRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPresignUrlRequestDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof IPresignUrlRequestDto
     */
    employee_id?: number;
}

/**
 * Check if a given object implements the IPresignUrlRequestDto interface.
 */
export function instanceOfIPresignUrlRequestDto(value: object): value is IPresignUrlRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IPresignUrlRequestDtoFromJSON(json: any): IPresignUrlRequestDto {
    return IPresignUrlRequestDtoFromJSONTyped(json, false);
}

export function IPresignUrlRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPresignUrlRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
    };
}

export function IPresignUrlRequestDtoToJSON(json: any): IPresignUrlRequestDto {
    return IPresignUrlRequestDtoToJSONTyped(json, false);
}

export function IPresignUrlRequestDtoToJSONTyped(value?: IPresignUrlRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'employee_id': value['employee_id'],
    };
}

